import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import Footer from "../components/Footer.tsx";
import HeaderMenu from "../components/HeaderMenu.tsx";
import Banner from "../components/core-components/Banner.tsx";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
`;

const Content = styled.div`
  flex-grow: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Layout = () => {
  const [isMobile, setIsMobile] = useState(false);

  const checkScreenSize = () => {
    // Use matchMedia to check for mobile screen size
    setIsMobile(window.matchMedia("(max-width: 820px)").matches);
  };

  useEffect(() => {
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  return (
    <Wrapper>
      {/* <Banner text={"Site în mentenanță ! Ne revedem după 1 iulie 2025 !"} /> */}
      <HeaderMenu isMobile={isMobile} />
      <Content data-testid="content">
        <Outlet />
      </Content>
      <Footer isMobile={isMobile} />
    </Wrapper>
  );
};

export default Layout;
